/* eslint-disable react-hooks/exhaustive-deps */
import { confirmDialog, CustomCollapseCard, Text } from '@src/components';
import { Radio } from 'antd';
import React, { useCallback, useEffect } from 'react';
import '@src/styles/balanceUpload/orderType.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
  prepareLoadBalance,
  setOrderStep,
  setCurrentLoadBalance,
  setExcelSuccess,
} from '@src/store/slice/balanceUploadSlice';
import { useHistory } from 'react-router-dom';
import { setDraftType } from '@src/store/slice/draftOrderSlice';
import {
  loadBalancePopUpMessage,
  setDetailTableFilterClear,
  setExcelUploadStatus,
  setSelectedBalanceUploadDetails,
  setBalanceUploadClear,
} from '@src/store/slice/balanceUploadDetailSlice';
import useUnload from '@src/hooks/useUnLoad.js';
import { VouIdCode } from '@src/store/enums';

const OrderType = () => {
  const history = useHistory();
  const { currentLoadBalance, excelLoadBalanceList, selectedRowKeys } = useSelector(
    (state) => state?.balanceUpload,
  );
  const { excelUploadStatus, balanceUploadDetails } = useSelector(
    (state) => state?.balanceUploadDetail,
  );
  const dispatch = useDispatch();

  const typeChangeProcess = async (isNewLoadBalance, newOrderProcessType) => {
    // Aynı orderProcessType tekrar seçildiğinde prepareLoadBalance no-op olsun;
    // her tıklamada 3 SP zinciri tetiklenmesini engeller.
    if (currentLoadBalance?.orderProcessType === newOrderProcessType) {
      return;
    }
    if (!isNewLoadBalance) {
      let data = {
        orderProcessType: newOrderProcessType,
        vouId: VouIdCode.Market,
      };
      data.willBeDeletedId = currentLoadBalance?.id;
      await dispatch(prepareLoadBalance(data));
      await dispatch(setSelectedBalanceUploadDetails([]));
    } else {
      let data = {
        orderProcessType: newOrderProcessType,
        vouId: VouIdCode.Market,
      };
      if (!isNewLoadBalance) {
        data.willBeDeletedId = currentLoadBalance?.id;
      }
      await dispatch(prepareLoadBalance(data));
      await dispatch(setSelectedBalanceUploadDetails([]));
    }
  };

  const handleDraft = async (newOrderProcessType) => {
    const body = { orderProcessType: newOrderProcessType };
    const action = await dispatch(loadBalancePopUpMessage(body));
    if (loadBalancePopUpMessage.fulfilled.match(action)) {
      confirmDialog({
        title: <Text t="attention" />,
        message: action?.payload?.message,
        okText: <Text t="yes" />,
        onOk: async () => {
          await dispatch(setDraftType(2));
          await dispatch(setSelectedBalanceUploadDetails([]));
          history.push('/ticket-restaurant/draft-order');
        },
      });
    }
  };

  useUnload(async (e) => {
    if (excelLoadBalanceList?.orderStep === 3 || currentLoadBalance?.orderProcessType === 3) {
      await dispatch(
        setCurrentLoadBalance({ ...currentLoadBalance, totalPrice: 0, totalCount: 0 }),
      );
    }
  });

  const callBackBalanceClear = useCallback(async () => {
    await dispatch(setBalanceUploadClear());
    await dispatch(setExcelSuccess(false));
  }, [dispatch, balanceUploadDetails, currentLoadBalance]);

  useEffect(async () => {
    const third = currentLoadBalance?.orderProcessType === 3 ? 3 : null;
    if (currentLoadBalance?.orderProcessType === 3) {
      await dispatch(setOrderStep(third));
    }
  }, [currentLoadBalance?.orderProcessType, dispatch]);

  const handlePreviousOrder = async (newOrderProcessType, isNewLoadBalance) => {
    await typeChangeProcess(isNewLoadBalance, newOrderProcessType);
    dispatch(setExcelUploadStatus(false));
    await dispatch(setOrderStep(1));
  };

  const calculateTotalPrice = (balanceTotalPrice) => {
    try {
      if (balanceTotalPrice === 0) {
        return balanceUploadDetails?.reduce((sum, item) => {
          const isSelected = selectedRowKeys?.some(
            (key) => key.split('balance-upload-')[1] === item.cardNumber,
          );
          return isSelected ? sum + item.price : sum;
        }, 0);
      }
    } catch (error) {
      console.error(error);
    }
    return balanceTotalPrice;
  };

  const orderTypeChange = async (e) => {
    dispatch(setDetailTableFilterClear());
    const newOrderProcessType = e.target.value;
    await dispatch(setOrderStep(newOrderProcessType));

    const isNewLoadBalance = currentLoadBalance?.id === 0;
    let balanceTotalPrice = Number(currentLoadBalance?.totalPrice);
    const balanceCurrentOrderType = currentLoadBalance?.orderProcessType;

    balanceTotalPrice = calculateTotalPrice(balanceTotalPrice);
    const confirmAndProceed = (onOk) => {
      confirmDialog({
        title: <Text t="attention" />,
        htmlContent: (
          <Text t="whenYouLeaveThisPageTheInformationYou2" />
        ),
        onOk,
      });
    };

    const resetAndProceed = async () => {
      await dispatch(setDraftType(newOrderProcessType));
      typeChangeProcess(isNewLoadBalance, newOrderProcessType);
    };

    if (newOrderProcessType === 4) {
      if (balanceTotalPrice !== 0) {
        confirmAndProceed(() => handleDraft(newOrderProcessType));
      } else {
        handleDraft(newOrderProcessType);
      }
      return null;
    }

    if (newOrderProcessType === 1) {
      if (balanceTotalPrice !== 0) {
        handlePreviousOrder(newOrderProcessType, isNewLoadBalance);
      } else {
        await dispatch(setOrderStep(null));

        handlePreviousOrder(newOrderProcessType, isNewLoadBalance);
      }
      return;
    }

    const shouldConfirm =
      (balanceCurrentOrderType === 2 && balanceTotalPrice !== 0) ||
      (balanceCurrentOrderType === 3 && excelUploadStatus);

    if (shouldConfirm) {
      confirmAndProceed(async () => {
        await resetAndProceed();
        if (balanceCurrentOrderType === 3 && excelUploadStatus) {
          dispatch(setExcelUploadStatus(false));
        }
      });
      return;
    }

    if (newOrderProcessType === 3) {
      callBackBalanceClear();
      const isExcelReset = excelLoadBalanceList?.orderStep === 3 || balanceCurrentOrderType === 3;
      if (isExcelReset) {
        await dispatch(
          setCurrentLoadBalance({ ...currentLoadBalance, totalPrice: 0, totalCount: 0 }),
        );
      }
    }
    typeChangeProcess(isNewLoadBalance, newOrderProcessType);
    dispatch(setExcelUploadStatus(false));
  };

  return (
    <CustomCollapseCard
      className={`order-type-card order-input-form-page`}
      bodyCenter
      cardTitle={<Text t="pleaseSelectOrderType" />}
      cardTitleAlign="center"
      titleColor="#1d2228"
      titleSize="16px"
      showExpandIcon={false}
    >
      <div className="order-type-container">
        <div className="card-checkbox-content" style={{ backgroundColor: '#e9ecef' }}>
          <Radio.Group
            id="ticketRestaurant-balanceUpload-balanceInformation-orderType-radioGroup"
            onChange={orderTypeChange}
            value={currentLoadBalance?.orderProcessType}
            className="custom-radio-input-credit-card order-balance-type-radio"
          >
            <div className="row justify-content-center">
              {currentLoadBalance?.isPreviousOrderExist && (
                <Radio id="ticketRestaurant-balanceUpload-balanceInformation-orderType-radio" value={1} className="card-radio" style={{ width: 260 }}>
                  <div className="card-label">
                    <Text t="repeatPreviousOrder" />
                  </div>
                  <p><Text t="youCanRepeatYourLastBalanceLoadingOrder" /></p>
                </Radio>
              )}
              <Radio
                id="ticketRestaurant-balanceUpload-balanceInformation-orderType-radio2"
                value={2}
                className="card-radio"
                style={{ width: 260 }}
              >
                <div className="card-label">
                  <Text t="manualBalanceLoading" />
                </div>
                <p>
                  <Text t="youCanEnterInformationForCardsYouWant" />
                </p>
              </Radio>
              <Radio
                id="ticketRestaurant-balanceUpload-balanceInformation-orderType-radio3"
                value={3}
                className="card-radio"
                style={{ width: 260 }}
              >
                <div className="card-label">
                  <Text t="balanceUploadWithExcel" />
                </div>
                <p>
                  <Text t="youCanUploadAnExcelFileForInformation" />
                </p>
              </Radio>
            </div>
          </Radio.Group>
        </div>
      </div>
    </CustomCollapseCard>
  );
};

export default OrderType;
